import React from 'react';
import { Select } from 'antd';
import { cn } from './_cn';

// Same tab-strip visual language as the one on the company detail page
// (src/views/company/company-detail/company-detail.js): a row of
// `rounded-full` pill buttons that wraps onto further lines as it runs out
// of width — the active one in the app's blue on light, sky on dark —
// collapsing to a plain select at phone width. Two things differ from that
// original, both deliberate: an icon per tab is optional here rather than
// required, and this component is controlled — it holds no state of its
// own, so a caller can keep the selected tab anywhere it likes (the URL,
// for instance).
const TWTabNav = ({ tabs, value, onChange, ariaLabel }) => (
  <>
    <div className="sm:hidden">
      <Select
        size="large"
        className="tw-tab-nav-select"
        style={{ width: '100%' }}
        aria-label={ariaLabel}
        value={value}
        onChange={(nextId) => onChange(nextId)}
        options={tabs.map((tab) => ({ label: tab.label, value: tab.id }))}
      />
    </div>
    <nav className="hidden overflow-x-auto sm:block" aria-label={ariaLabel}>
      <div className="flex flex-wrap gap-2" role="tablist">
        {tabs.map((tab) => {
          const isActive = tab.id === value;
          const TabIcon = tab.icon;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(tab.id)}
              aria-current={isActive ? 'true' : undefined}
              className={cn(
                'inline-flex h-10 items-center gap-2 rounded-full border px-4 text-sm font-semibold transition',
                isActive
                  ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-sm dark:border-sky-400 dark:bg-sky-500/10 dark:text-sky-300'
                  : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:bg-slate-700/60',
              )}
            >
              {TabIcon ? <TabIcon className="h-4 w-4" /> : null}
              {tab.label}
            </button>
          );
        })}
      </div>
    </nav>
  </>
);

export default TWTabNav;
